import { SOGetInvoice } from '../invoice/so-get-invoice';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetPaymentIntent implements QueryProtocol {

  constructor(
    public uid: string = null,
    public invoice: SOGetInvoice = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetPaymentIntent(
      'uid' in params ? params.uid : null,
      'invoice' in params ? params.invoice : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
